export function initCountdowns(selector = '[data-countdown]') {
	if (typeof document === 'undefined') {
		return;
	}

	const els = document.querySelectorAll(selector);
	if (!els.length) {
		return;
	}

	const clamp = (n, min = 0) => (n < min ? min : n);
	const pad = (n) => (n < 10 ? `0${ n }` : `${ n }`);

	const renderSkeleton = (root) => {
		if (root.dataset.mounted === '1') {
			return;
		}
		root.classList.add('fui-countdown');
		root.innerHTML = `
      <div class="fui-countdown__row" aria-live="polite" aria-atomic="true">
        <div class="fui-countdown__unit"><span class="fui-countdown__num" data-cddays>00</span><span class="fui-countdown__label">DAYS</span></div>
        <div class="fui-countdown__unit"><span class="fui-countdown__num" data-cdhours>00</span><span class="fui-countdown__label">HOURS</span></div>
        <div class="fui-countdown__unit"><span class="fui-countdown__num" data-cdmins>00</span><span class="fui-countdown__label">MINS</span></div>
        <div class="fui-countdown__unit"><span class="fui-countdown__num" data-cdsecs>00</span><span class="fui-countdown__label">SECS</span></div>
      </div>
      <div class="fui-countdown__sub" data-cdsub></div>
    `;
		root.dataset.mounted = '1';
	};

	els.forEach((root) => {
		const targetStr = (root.getAttribute('data-countdown-until') || '').trim();
		if (!targetStr) {
			return;
		}

		const endText = (root.getAttribute('data-countdown-end-text') || '').trim();
		const label = (root.getAttribute('data-countdown-text') || '').trim();

		renderSkeleton(root);

		if (label) {
			const sub = root.querySelector('[data-cdsub]');
			if (sub) {
				sub.textContent = label;
			}
		}

		const target = new Date(targetStr);
		if (isNaN(target.getTime())) {
			const sub = root.querySelector('[data-cdsub]');
			if (sub) {
				sub.textContent = 'Invalid date';
			}
			return;
		}

		const $d = root.querySelector('[data-cddays]');
		const $h = root.querySelector('[data-cdhours]');
		const $m = root.querySelector('[data-cdmins]');
		const $s = root.querySelector('[data-cdsecs]');

		let raf;
		let timer;

		const finish = () => {
			$d.textContent = '00';
			$h.textContent = '00';
			$m.textContent = '00';
			$s.textContent = '00';
			if (endText) {
				const sub = root.querySelector('[data-cdsub]');
				if (sub) {
					sub.textContent = endText;
				}
			}
			clearInterval(timer);
			cancelAnimationFrame(raf);
		};

		const update = () => {
			const now = new Date();
			let diff = target.getTime() - now.getTime();
			if (diff <= 0) {
				return finish();
			}

			diff = clamp(diff, 0);
			const secsTotal = Math.floor(diff / 1000);

			const days = Math.floor(secsTotal / 86400);
			const hours = Math.floor((secsTotal % 86400) / 3600);
			const mins = Math.floor((secsTotal % 3600) / 60);
			const secs = secsTotal % 60;

			$d.textContent = pad(days);
			$h.textContent = pad(hours);
			$m.textContent = pad(mins);
			$s.textContent = pad(secs);
		};

		raf = requestAnimationFrame(update);
		timer = setInterval(update, 1000);

		const onVis = () => {
			if (!document.hidden) {
				update();
			}
		};
		document.addEventListener('visibilitychange', onVis, { passive: true });

		root._fuiCountdownDestroy = () => {
			clearInterval(timer);
			cancelAnimationFrame(raf);
			document.removeEventListener('visibilitychange', onVis);
		};
	});
}
